import { z } from 'zod'

export const triggerConfigSchema = z.object({
  keyword: z
    .object({
      keywords: z.array(z.string()),
      matchMode: z.enum(['contains', 'exact', 'starts_with', 'ends_with']),
    })
    .optional(),
  webhook: z
    .object({
      url: z.string(),
      actionType: z.enum(['AGENT', 'ROUTING']),
      agentId: z.number().optional(),
      flowId: z.number().optional(),
    })
    .optional(),
  segment: z
    .object({
      segmentId: z.number(),
    })
    .optional(),
})

export const actionConfigSchema = z.object({
  routing: z
    .object({
      targetType: z.enum(['flow', 'department', 'attendant']),
      flowId: z.number().optional(),
      departmentId: z.number().optional(),
      attendantId: z.string().optional(),
      targetName: z.string().optional(),
    })
    .optional(),
  agent: z
    .object({
      agentId: z.number(),
    })
    .optional(),
})

export const automationStatsSchema = z.object({
  executionCount: z.number(),
  lastExecution: z.string().nullable(),
  successRate: z.number(),
})

export const automationSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  triggerType: z.enum(['KEYWORD', 'SCHEDULE', 'EVENT', 'CONDITION']),
  triggerConfig: triggerConfigSchema,
  actionType: z.enum(['WORKFLOW', 'ROUTING', 'AGENT']),
  actionConfig: actionConfigSchema,
  priority: z.number().optional(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  stats: automationStatsSchema,
})

export type Automation = z.infer<typeof automationSchema>
